import { Controller } from "@hotwired/stimulus"

// This controller is used to search filter options in a list of filters.
export default class extends Controller {
  static get targets() {
    return ["searchInput"]
  }

  search() {
    const query = this.searchInputTarget.value.toLowerCase().trim()
    const controlledElementId = this.searchInputTarget.getAttribute("aria-controls")
    const controlledElement = document.getElementById(controlledElementId)

    const noResultsElement = controlledElement.querySelector(".dropdown-search-no-results")
    const listItems = controlledElement.querySelectorAll("li:not(.dropdown-search-no-results)")

    if (query.length === 0) {
      listItems.forEach(item => {
        item.classList.remove("d-none")
      })

      if (noResultsElement) {
        noResultsElement.classList.add("d-none")
      }
      return
    }

    let visibleCount = 0
    listItems.forEach(item => {
      const itemText = item.innerText.trim().toLowerCase()

      if (itemText.includes(query)) {
        item.classList.remove("d-none")
        visibleCount++
      } else {
        item.classList.add("d-none")
      }
    })

    if (noResultsElement) {
      if (visibleCount === 0) {
        noResultsElement.classList.remove("d-none")
      } else {
        noResultsElement.classList.add("d-none")
      }
    }
  }
}
